import React from 'react';
import SEO from '../components/SEO';

const sections = [
  {
    title: 'Customer Service Contact',
    content: `For any questions regarding our services or these terms, please contact us at contact@p2pdigital.com.au. Our team is committed to responding within 24 hours during business days.`,
  },
  {
    title: 'Service Terms',
    content: `P2P Digital provides technology consulting services including medical device development, software engineering, and AI solutions. All engagements are governed by a Statement of Work (SOW) agreed upon by both parties prior to project commencement. The SOW will outline project scope, deliverables, timelines, and associated costs. Any changes to the agreed scope must be documented through a formal change request process.`,
  },
  {
    title: 'Payment Terms',
    content: `Payment terms are outlined in individual project agreements. Standard terms require payment within 30 days of invoice date unless otherwise specified in the SOW. For project-based engagements, milestone-based payments may apply as defined in the project agreement. Late payments may incur interest at a rate of 2% per month on the outstanding balance.`,
  },
  {
    title: 'Cancellation Policy',
    content: `Either party may terminate an engagement by providing 14 days written notice. In the event of cancellation, the client is responsible for payment of all work completed up to the date of termination, plus any non-cancellable third-party costs incurred on behalf of the project. Prepaid fees for uncompleted work will be refunded on a pro-rata basis.`,
  },
  {
    title: 'Intellectual Property',
    content: `Unless otherwise specified in the SOW, all intellectual property created during the engagement will be assigned to the client upon full payment. P2P Digital retains the right to use general knowledge, skills, and experience gained during the engagement. Pre-existing IP belonging to either party remains the property of the original owner.`,
  },
  {
    title: 'Confidentiality',
    content: `Both parties agree to maintain the confidentiality of all proprietary information shared during the engagement. This obligation survives the termination of any agreement and remains in effect for a period of five years following disclosure. Confidential information does not include information that is publicly available or independently developed.`,
  },
  {
    title: 'Refund & Dispute Policy',
    content: `If you are unsatisfied with any aspect of our services, please contact us within 14 days of the relevant deliverable. We are committed to resolving any disputes through good-faith negotiation. If a resolution cannot be reached, disputes will be handled through mediation before any formal proceedings.`,
  },
  {
    title: 'Updates to Terms',
    content: `P2P Digital reserves the right to update these terms at any time. Significant changes will be communicated to active clients via email. Continued use of our services following any updates constitutes acceptance of the revised terms. The most current version of these terms will always be available on our website.`,
  },
];

const Terms = () => {
  return (
    <>
      <SEO
        title="Terms & Conditions"
        description="Terms and conditions for P2P Digital consulting services."
        path="/terms"
        noindex={true}
      />
      <div>
        {/* Hero */}
        <section className="relative pt-32 pb-20 overflow-hidden">
          <div className="absolute w-[500px] h-[500px] bg-cyan-500/10 rounded-full blur-[120px] -top-40 -right-40" />
          <div className="absolute w-[400px] h-[400px] bg-indigo-500/10 rounded-full blur-[120px] bottom-0 -left-40" />
          <div className="relative max-w-7xl mx-auto px-6 text-center">
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-cyan-400">Legal</p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight mt-4">
              Terms &{' '}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-indigo-400">Policies</span>
            </h1>
            <p className="mt-6 text-lg text-slate-400 max-w-2xl mx-auto">
              Our commitment to transparency and professional service.
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 max-w-4xl mx-auto px-6">
          <div className="bg-white/[0.04] backdrop-blur-xl border border-white/[0.06] rounded-2xl p-8 lg:p-12">
            <div className="space-y-10">
              {sections.map((section) => (
                <div key={section.title}>
                  <h2 className="font-display text-xl font-bold text-white mb-4">{section.title}</h2>
                  <p className="text-slate-300 leading-relaxed">
                    {section.title === 'Customer Service Contact' ? (
                      <>
                        For any questions regarding our services or these terms, please contact us at{' '}
                        <a href="mailto:contact@p2pdigital.com.au" className="text-cyan-400 hover:underline">
                          contact@p2pdigital.com.au
                        </a>
                        . Our team is committed to responding within 24 hours during business days.
                      </>
                    ) : (
                      section.content
                    )}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Terms;
